import React, { useState } from "react";
import { Slider } from "primereact/slider";
import homeConfig from "src/resources/homePage.json";
import { Trans, useTranslation } from "react-i18next";
import ArrowCircleLeftOutlinedIcon from "@mui/icons-material/ArrowCircleLeftOutlined";
import ArrowCircleRightOutlinedIcon from "@mui/icons-material/ArrowCircleRightOutlined";
import useResize from "src/hooks/useResize";
const SystemOverview = () => {
  const { t } = useTranslation(["common", "homePage"]);
  const systemOverview = homeConfig.systemOverview;
  const [value, setValue] = useState(1);

  const moveSlideTo = (slideNumber: number) => () => {
    setValue(slideNumber);
  };

  const moveSlideToPrev = (): void => {
    setValue((prevValue) => (prevValue === 1 ? 4 : prevValue - 1));
  };

  const moveSlideToNext = () => {
    setValue((prevValue) => (prevValue === 4 ? 1 : prevValue + 1));
  };

  const { isMobile } = useResize();

  return (
    <section className="home-section benefits w-100" id="system-overview">
      <div
        className="d-flex justify-content-center align-items-center system-overview "
        style={{
          backgroundImage: `url(${require(`src/assets/images/system-overview/${
            isMobile
              ? systemOverview.image.mobileName
              : systemOverview.image.name
          }`)})`,
          backgroundPosition: "center",
          position: "relative",
          backgroundSize: "cover",
          backgroundRepeat: "no-repeat",
        }}
      >
        {/* <div className="overlay"></div> */}
        <div className="main-benefit d-flex justify-content-center align-items-start w-100 system-overview-content">
          <div className="d-flex justify-content-center align-items-start flex-column introduction">
            <h6>{t(`homePage.systemOverview.subTitle`)}</h6>
            <h2>{t(`homePage.systemOverview.title`)}</h2>
            <h4>{t(`homePage.systemOverview.content`)}</h4>
            <p>{t(`homePage.systemOverview.subContent`)}</p>
          </div>
          <Trans>
            <div className="slides d-flex justify-content-center align-items-center flex-column">
              {value === 1 && (
                <div className="d-flex align-items-start slides-container">
                  <div className="slide side-1">
                    <h3>{t(`homePage.systemOverview.items.item1.title`)}</h3>
                    <p>{t(`homePage.systemOverview.items.item1.content`)}</p>
                  </div>
                  <div className="slide-partition cursor-pointer" >
                    <div className="slide side-2" onClick={moveSlideTo(2)}>
                      <img
                        src={`${require(`src/assets/images/system-overview/${systemOverview.slides.slide2.name}`)}`}
                        alt={systemOverview.slides.slide2.alt}
                      />
                      <p>{t(`homePage.systemOverview.items.item2.title`)}</p>
                      <p className="mt-3">
                        {t(`homePage.systemOverview.items.item2.content`)}
                      </p>
                    </div>
                  </div>
                </div>
              )}
              {value === 2 && (
                <div className="d-flex align-items-start slides-container">
                  <div className="slide side-2">
                    <img
                      src={`${require(`src/assets/images/system-overview/${systemOverview.slides.slide2.name}`)}`}
                      alt={systemOverview.slides.slide2.alt}
                    />
                    <p>{t(`homePage.systemOverview.items.item2.title`)}</p>
                    <p className="mt-3">
                      {t(`homePage.systemOverview.items.item2.content`)}
                    </p>
                  </div>
                  <div className="slide-partition cursor-pointer" >
                    <div className="slide side-3" onClick={moveSlideTo(3)}>
                      <h3>{t(`homePage.systemOverview.items.item3.title`)}</h3>
                      <p>{t(`homePage.systemOverview.items.item3.content`)}</p>
                    </div>
                  </div>
                </div>
              )}
              {value === 3 && (
                <div className="d-flex align-items-start slides-container">
                  <div className="slide side-3">
                    <h3>{t(`homePage.systemOverview.items.item3.title`)}</h3>
                    <p>{t(`homePage.systemOverview.items.item3.content`)}</p>
                  </div>
                  <div className="slide-partition cursor-pointer" >
                    <div className="slide side-4" onClick={moveSlideTo(4)}>
                      <img
                        src={`${require(`src/assets/images/system-overview/${systemOverview.slides.slide4.name}`)}`}
                        alt={systemOverview.slides.slide4.alt}
                      />
                      <p>{t(`homePage.systemOverview.items.item4.content`)}</p>
                    </div>
                  </div>
                </div>
              )}
              {value === 4 && (
                <div className="d-flex align-items-start slides-container">
                  <div className="slide side-4">
                    <img
                      src={`${require(`src/assets/images/system-overview/${systemOverview.slides.slide4.name}`)}`}
                      alt={systemOverview.slides.slide4.alt}
                    />
                    <p>{t(`homePage.systemOverview.items.item4.content`)}</p>
                  </div>
                  <div className="slide-partition cursor-pointer" >
                    <div className="slide side-1" onClick={moveSlideTo(1)}>
                      <h3>{t(`homePage.systemOverview.items.item1.title`)}</h3>
                      <p>{t(`homePage.systemOverview.items.item1.content`)}</p>
                    </div>
                  </div>
                </div>
              )}

              <div className="d-flex justify-content-center slider">
                <ArrowCircleLeftOutlinedIcon
                  className="slide-arrow back-arrow"
                  onClick={moveSlideToPrev}
                />
                <Slider
                  value={value}
                  onChange={(e) => setValue(e.value as number)}
                  className="w-100"
                  min={1}
                  max={4}
                  step={1}
                />
                <ArrowCircleRightOutlinedIcon
                  className="slide-arrow forward-arrow"
                  onClick={moveSlideToNext}
                />
              </div>
            </div>
          </Trans>
        </div>
      </div>
    </section>
  );
};

export default SystemOverview;
